<template>
<div v-loading="loading" >
  <w-transaction-info-view class="mr-b15" :tx-info="txInfo" />
  <el-tree :data="callTreeData" :props="defaultProps" :default-expand-all="true" :expand-on-click-node="false">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span v-if="data.treeKey === -1" class="group">{{data.label}}</span>
      <span v-else class="obj-icon">
        <i :class="getStepTypeIconClass(data)" />
        <span c>{{data.label}}</span>
      </span>
    </span>
  </el-tree>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { defaultProps } from '@/constants/tree';
import TransactionAPI from '@/api/apm/transaction';
import WTransactionInfoView from './TransactionInfoView';
import { TX_ID_STRING, OBJ_HASH } from '@/constants/apm-domain-define';

export default {
  name: 'WCallTreeView',
  components: { WTransactionInfoView },
  props: {
    activeTab: String,
    params: Object,
  },
  data() {
    return {
      defaultProps,
      callTreeData: [],
      loading: false,
      txInfo: {},
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    activeTab() {
      this.loadData();
    },
    params() {
      this.loadData();
    },
  },
  methods: {
    /**
     * call tree 데이터 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.activeTab !== 'calltree' || isEmpty(this.params)) {
        return;
      }
      this.loading = true;
      // 트리
      const requestParam = {};
      requestParam[TX_ID_STRING] = this.params.txid;
      requestParam[OBJ_HASH] = this.selectedNode.objHash;
      TransactionAPI.getCallTree(requestParam).then((response) => {
        this.loading = false;
        if (response.data.success) {
          const result = response.data.data;
          this.callTreeData = result.profile;
          this.txInfo = result.tx;
        } else {
          this.txInfo = {};
          this.callTreeData = [];
        }
      });
    },
    reset() {
      this.txInfo = {};
      this.callTreeData = [];
    },
    /**
     * 단게 아이콘 표현
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     * @author jda
     */
    getStepTypeIconClass(data) {
      const stepType = data.stepType;
      let iconClass;
      if (stepType === '1' || stepType === '10' || stepType === '11') { // METHOD
        iconClass = 'fas fa-function';
      } else if (stepType === '2' || stepType === '8' || stepType === '16' || stepType === '21') { // SQL
        iconClass = 'fas fa-database';
      } else if (stepType === '3' || stepType === '9' || stepType === '17' || stepType === '31') { // MESSAGE
        iconClass = 'fas fa-align-left';
      } else if (stepType === '5' || stepType === '42') { // SOCKET
        iconClass = 'fas fa-network-wired';
      } else if (stepType === '6' || stepType === '15' || stepType === '43' || stepType === '13') { // API CALL, DISPATCH
        iconClass = 'fas fa-file';
      } else if (stepType === '7' || stepType === '14') { // THREAD
        iconClass = 'fas fa-sync-alt';
      } else if (stepType === '12') { // DUMP
        iconClass = 'fas fa-coins';
      } else {
        iconClass = null;
      }
      return iconClass;
    },
  },
};
</script>

<style scoped>
.el-tree-node__label{
  white-space: pre-wrap !important;
}
</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/CallTreeView.vue